import React, {useEffect} from "react"
import {MDBRow, MDBCol, MDBBreadcrumb, MDBBreadcrumbItem, MDBCard, MDBCardBody, MDBCardTitle} from "mdbreact"
import TestsGrid from "../../components/DvsaTest/TestsGrid"
import AxleGrid from "../../components/DvsaTest/AxleGrid"
import TestTypeGrid from "../../components/DvsaTest/TestTypeGrid"
import DvsaTestsChargesGrid from "../../components/DvsaTest/DvsaTestsChargesGrid"
import {useAppDispatch} from "../../store"
import {getAxles, getTests, getTestTypes, getTestCosts} from "./dvsatestsSlice"
const DvsaTest = () => {
    const dispatch = useAppDispatch()
    useEffect(() => {
        dispatch(getAxles())
        dispatch(getTestTypes())
        dispatch(getTests())
        dispatch(getTestCosts())
    }, [dispatch])

    return (
        <>
            <MDBBreadcrumb>
                <MDBBreadcrumbItem> Settings </MDBBreadcrumbItem>
                <MDBBreadcrumbItem active>DVSA Tests</MDBBreadcrumbItem>
            </MDBBreadcrumb>

            <div>
                <MDBRow>
                    <MDBCol md="5" className="pe-0">
                        <MDBCard className="mb-2">
                            <MDBCardBody className="p-2">
                                <MDBCardTitle className="text-muted">Tests</MDBCardTitle>
                                <TestsGrid />
                            </MDBCardBody>
                        </MDBCard>
                        <MDBCard className="mb-2">
                            <MDBCardBody className="p-2">
                                <MDBCardTitle className="text-muted">Axles</MDBCardTitle>
                                <AxleGrid />
                            </MDBCardBody>
                        </MDBCard>
                        <MDBCard>
                            <MDBCardBody className="p-2">
                                <MDBCardTitle className="text-muted">Test Types</MDBCardTitle>
                                <TestTypeGrid />
                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>
                    <MDBCol md="7">
                        <MDBCard>
                            <MDBCardBody className="p-2">
                                <MDBCardTitle className="text-muted">DVSA Tests Fee</MDBCardTitle>
                                <DvsaTestsChargesGrid />
                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>
                </MDBRow>
            </div>
        </>
    )
}

export default DvsaTest
